import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import "../../css/course-page.css";
import "../../css/main-mobile-view.css";
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBell } from '@fortawesome/free-solid-svg-icons'
import Intrestedinprogram from './intrestedinprogram';

class Machinelearning extends Component {
    render() {
        return (
            <div>
                <div aria-label="breadcrumb">
                    <ol class="breadcrumb def-z course-m">
                        <li class="breadcrumb-item">
                            <Link href=""><i class="icon-home"></i>HOME </Link>
                        </li>
                        <li class="breadcrumb-item active">Online Machine Learning Course</li>
                    </ol>
                </div>

                <section class="course-header bg-blue1" id="course-header">
                    <div class="row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                            <h1>Online Machine Learning Course</h1>
                            <p>Dive deep into Machine Learning. Get the Perfect Blend of Analytical Skills & Business Knowledge. </p>
                            <br />
                            <div class="row">
                                <button class="pulse-button" type="button" data-toggle="modal" onclick="startvideo()" data-target="#myModalq"></button>
                                <p class="Watch-Intro">Watch Intro Video </p>
                            </div>
                            <br />
                            <div class="form-group">
                                <Link href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </Link>
                                <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                                    data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/online-machine-learning-course');">Download
                        brochure</button>
                            </div>  <br />  <br />
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                            <p>Jointly Delivered by </p>
                            <ul>
                                <li><img width="" src="/assets/images/epn.svg" alt="epn" /></li>
                                <li>Vijay Gaikwad</li>
                            </ul>
                            <br />
                        </div>
                    </div>
                </section>
                <div class="course-main-contains def-z" id="Description">
                    <div class="card">
                        <div class="row contanint-display">
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b>What's included :<br />
                                    <i class="fa fa-mobile" ></i> &nbsp;&nbsp;Mobile Support</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">
                                <b><i class="fa fa-comments" ></i> &nbsp; Discussion Forum</b><br />
                                <b><i class="fa fa-certificate" ></i> &nbsp; Course Certificate</b>
                            </div>
                            <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4"    >
                                <b><i class="fa fa-question" ></i> &nbsp;&nbsp;&nbsp;Quiz</b><br />
                                <b>Online Compiler</b>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="def-z">
                    <div class="header" id="myHeader">
                        <ul>
                            <li><a href="#Description">Description</a></li>
                            <li><a href="#Role">Job Roles</a></li>
                            <li><a href="#Industry">Industry Trends</a></li>
                            <li><a href="#Tools">Tools</a></li>
                            <li><a href="#Syllabus">Syllabus</a></li>
                            <li><a href="#Learning-Outcomes">Learning Outcomes</a></li>
                            <li><a href="#Reviews">Learner Review </a></li>
                            <li><a href="#Instructor">About Instructor</a></li>
                            <li class="btn-header cs-dx"><a href="#apply-now">Apply Now</a></li>
                        </ul>
                    </div>
                </section>
                <section class="course-description" id="course-description">
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">An Overview Of Our Online Machine Learning Course</h3>
                            <p align="justify">One of the best online courses for machine learning has been devised by experts from the Vishwakarma Institute of Technology, Pune. Now you can also take advantage & learn machine learning online by attending this online class where you get a holistic education and understanding of machine learning. This online machine learning course is applicable for PAN India students and professionals and the certificate will be furnished by Edu Plus Now, Pune. This machine learning certification training covers a comprehensive syllabus where you will be imparted the know-hows of tools like Python that comes in handy on the job. This online machine learning course by Edu Plus Now is highly accredited & by far the best rated machine learning courses in Pune and one of the best in India right now.</p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">Best Online Course For Machine Learning</h3>
                            <p align="justify">This online course, designed by an expert from the Vishwakarma Institute of Technology Pune, provides a complete understanding of Machine Learning.
                            The Certificate in Machine Learning course is designed to share the knowledge and help you learn complex theory, algorithms and coding libraries in a simple way.It will show step-by-step developments of Machine Learning algorithms that are used to solve real-world problems.
                     </p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">What Is Machine Learning ?</h3>
                            <p align="justify">Machine learning is an application of artificial intelligence (AI) that renders systems the ability to learn and improve from experience without being explicitly programmed. It focuses on the development of computer programs that can access data and use it to learn for themselves.</p>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab" id="Role">The Key Features Of This Online Machine Learning Course </h3>
                            <p align="justify">
                                <ul class="highlight-ss">
                                    <li>	Dr.Vijay Gaikwad as a knowledge partner.</li>
                                    <li>	Mentorship by industry specialists.</li>
                                    <li>	Course awarded by Edu Plus Now.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <br />
                    <h3 class="heading-tab">Job Roles According To The Industry You Might Be Interested In </h3>
                    <br />
                    <div class="row">
                        <div class="col-sm-12 col-lg-4 ">
                            <div class="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/Finance.jpg" class="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the Finance industry, you can work as a strategic decision maker or in the risk analytics department.<br /><br /><br />
                                </p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-4 ">
                            <div class="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/bank.jpg" class="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the Banking industry, you can work as a fraud detector or create models to measure credit risks.<br /><br /><br /><br />
                                </p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-4 ">
                            <div class="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/healthcare.jpg" class="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the healthcare industry, you can take up the role of a drug researcher where you can research and discover the drugs that will help in curing a particular disease. You can also become a virtual assistant.
                        </p>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div class="row">
                        <div class="col-sm-12 col-lg-4 ">
                            <div class="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/E-commerce.jpg" class="img-trens" alt="Industry Trends" />
                                <p align="justify">
                                    In the E-commerce industry, you can work as a researcher who aims at studying consumer behaviours and recommend products to the consumers based on the searching and buying history.
                        </p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-4 ">
                            <div class="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/Transport.jpg" class="img-trenst" alt="Industry Trends" />
                                <p align="justify"><br />
                           In the Transport industry, you can work at the passengers safety department to enhance the safety of the passengers in transit. You can also monitor the transport systems.<br /><br />
                                </p>
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg-4 ">
                            <div class="cards">
                                <img src="/assets/images/icons/six-sigma-bkg/manufacturing.jpg" class="img-trens" alt="Industry Trends" />
                                <p align="justify"><br />
                           In the Manufacturing industry, you can predict the potential problems in the products that are being manufactured or at the automation department of the manufacturing units.<br /><br />
                                </p>
                            </div>
                        </div>
                    </div>
                    <br /><br />
                    <div class="row">
                        <div class="col-sm-12">
                            <h3 class="heading-tab">Who Will Benefit From The Machine Learning Certification Course?</h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>	Candidates who are willing to learn machine learning algorithms with Python.</li>
                                <li>	Candidates harboring an interest in the practical applications of machine learning to the real-world problems</li>
                                <li>	Anyone who wants to add value to their business through powerful Machine Learning tools.</li>
                                <li>	Budding engineers who want to build a career in Machine Learning.</li>
                                <li>	Teachers who are interested in Machine Learning certification.</li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <ul class="highlight-ss">
                                <li>	An intermediate or advanced level EXCEL practitioner who is unable to work with extensive datasets.</li>
                                <li>	Industry Professionals who are interested in online Machine Learning courses.</li>
                                <li id="Industry">	UG/ PG/ PhD students who are looking for Machine Learning training.</li>
                                <li>	Anyone who wants to add machine learning to their area of expertise.</li>
                                <li>	Students/professionals who wish to understand beyond the basics and gain a holistic understanding of the whole range of machine learning algorithms.</li>
                            </ul>
                        </div>
                    </div>
                </section>
                <section class="course-industry-trends bg-secondary" id="course-industry-trends">
                    <div class="row" >
                        <div class=" col-sm-6">
                            <h3> Industry Trends </h3>
                            <br />
                            <h5 >Job Roles</h5>
                            <ul class="industry-trends-ul">
                                <li>Data Analyst </li>
                                <li>Data Engineer </li>
                                <li>Data Scientist </li>
                                <li id="Tools">Business Analyst </li>
                                <li>Machine Learning Engineer </li>
                            </ul>
                        </div>
                        <div class="col-sm-6">
                            <img src="/assets/images/icons/industry-trends.png" alt="Industry Trends" />
                        </div>
                    </div>
                </section>
                <section class="course-tools-covered" >
                    <br />
                    <h2 > Tools Covered</h2><br />
                    <div class="row">
                        <div class="col-md-3 col-sm-12">
                            <div class="card cards-singles">
                                <center id="Syllabus"><img alt="python-logo" src="/assets/images/icons/python-logo.svg" style={{ "height": "150px", "width": "150px" }} /> </center>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-syllabus " id="course-syllabus">
                    <div class="row" >
                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                            <h3> What Will You Learn In Online Machine Learning Classes</h3>
                            <br />
                            <div class="syl-bg">
                                <div id="de_syllabus">
                                    <div class="panel-group">
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                                href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                                <h6 class="panel-title">
                                                    Introduction to Machine Learning <i class="indicator fa fa-minus"></i>
                                                </h6>
                                            </div>
                                            <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> About Machine Learning </li>
                                                        <li> Performance of Machine Learning Models </li>
                                                        <li> Types of Machine Learning </li>
                                                        <li> Algorithms and Applications of Machine Learning</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                                href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Data Pre-processing
                                                </h6>
                                            </div>
                                            <div id="de_syllabus2" class="collapse " aria-labelledby="de_heading2"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li> Data Pre-processing</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                                href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Installation Steps - Spyder(Python)
                                 </h6>
                                            </div>
                                            <div id="de_syllabus3" class="collapse " aria-labelledby="de_heading3"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Installation Details</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                                href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Simple Linear Regression
                                 </h6>
                                            </div>
                                            <div id="de_syllabus4" class="collapse " aria-labelledby="de_heading4"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Simple Linear Regression</li>
                                                        <li>Simple Linear Regression Equation</li>
                                                        <li> Simple Linear Regression how It works ?</li>
                                                        <li>  Simple Linear Regression Algorithm</li>
                                                        <li>  Simple Linear Regression Program</li>
                                                        <li> Reading the SLR dataset</li>
                                                        <li> Dividing the SLR dataset in DV & IV</li>
                                                        <li> Preparing the training set and testing set for SLR mode</li>
                                                        <li> Training the SLR Model</li>
                                                        <li>  Graphical results of SLR model</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading5" data-toggle="collapse"
                                                href="#de_syllabus5" aria-expanded="true" aria-controls="de_syllabus5">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Multiple Linear Regression
                                 </h6>
                                            </div>
                                            <div id="de_syllabus5" class="collapse " aria-labelledby="de_heading5"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Multiple Linear Regression Model</li>
                                                        <li>  Equation of Multiple Linear Regression</li>
                                                        <li> How Multiple Linear Regression Is Useful ?</li>
                                                        <li>Significance of Backward Elimination and 'P- Value'</li>
                                                        <li> Algorithm for Multiple Linear Regression</li>
                                                        <li> Importing the libraries for MLR model</li>
                                                        <li> Dividing the data set into training and testing set for MLR model</li>
                                                        <li> Training the MLR model</li>
                                                        <li>Building optimal MLR model</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading6" data-toggle="collapse"
                                                href="#de_syllabus6" aria-expanded="true" aria-controls="de_syllabus6">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i>  Polynomial Regression
                                 </h6>
                                            </div>
                                            <div id="de_syllabus6" class="collapse " aria-labelledby="de_heading6"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Polynomial Linear Regression (PLR)</li>
                                                        <li>Comparison: SLR Vs PLR</li>
                                                        <li>Reading the libraries and dataset for PLR</li>
                                                        <li>Fitting the model onto training data set</li>
                                                        <li>Linear Regression Results on PLR dataset</li>
                                                        <li>Applying the PLR onto the data set</li>
                                                        <li>PLR Results</li>
                                                        <li>Accuracy of PLR</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading7" data-toggle="collapse"
                                                href="#de_syllabus7" aria-expanded="true" aria-controls="de_syllabus7">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Logistic Regression
                                 </h6>
                                            </div>
                                            <div id="de_syllabus7" class="collapse " aria-labelledby="de_heading7"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Classification Part-I</li>
                                                        <li>Introduction to Classification Part-II</li>
                                                        <li>Logistic Regression (LR)-I</li>
                                                        <li>Logistic Regression (LR)-II</li>
                                                        <li>Algorithm for Logistic Regression (LR)</li>
                                                        <li>Develop Code of Logistic Regression -I</li>
                                                        <li>Code of Logistic Regression -II</li>
                                                        <li>Code of Logistic Regression -III</li>
                                                        <li>Feature Scaling</li>
                                                        <li>Fitting LR Module To Training Data set</li>
                                                        <li>Making The Confusion Matrix</li>
                                                        <li>Visualizing training set results</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading8" data-toggle="collapse"
                                                href="#de_syllabus8" aria-expanded="true" aria-controls="de_syllabus8">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Support Vector Machine Classifier
                                 </h6>
                                            </div>
                                            <div id="de_syllabus8" class="collapse " aria-labelledby="de_heading8"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Support Vector Machine Introduction</li>
                                                        <li>Maximum Margin Hyper-plane</li>
                                                        <li>Algorithm for Support Vector Machine (SVM)</li>
                                                        <li>Program for Support Vector Machine (SVM) Classifier</li>
                                                        <li>Splitting Data set for Support Vector Machine (SVM)</li>
                                                        <li>Fitting the Support Vector Machine (SVM) Model to Training Set</li>
                                                        <li>Prediction using Support Vector Machine (SVM)</li>
                                                        <li>Visualizing The Support Vector Machine Results</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading9" data-toggle="collapse"
                                                href="#de_syllabus9" aria-expanded="true" aria-controls="de_syllabus9">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i>Kernel SVM
                                 </h6>
                                            </div>
                                            <div id="de_syllabus9" class="collapse " aria-labelledby="de_heading9"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Examples of Kernels in SVM</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading10" data-toggle="collapse"
                                                href="#de_syllabus10" aria-expanded="true" aria-controls="de_syllabus10">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i>Naive Bayes Classifier
                                 </h6>
                                            </div>
                                            <div id="de_syllabus10" class="collapse " aria-labelledby="de_heading10"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Naive Base Classifier- I</li>
                                                        <li> Naive Base Classifier- II</li>
                                                        <li>Problem Statement for Naive Base Classifier (NCB)</li>
                                                        <li>Bayes Theorem</li>
                                                        <li>Bayes Theorem- Examples</li>
                                                        <li>Probability Calculation Using Bayes Theorem)</li>
                                                        <li> Summery with Examples for Naive Base Classifier (NCB)</li>
                                                        <li> Program for Naive Base Classifier (NCB)</li>
                                                        <li>NBC divide data set into training set and testing set</li>
                                                        <li>Fitting Naive Base Classifier (NCB)</li>
                                                        <li>NBC Machine confusion matrix</li>
                                                        <li>NBC visualizing the training set data</li>
                                                        <li> NBC visualizing the test set data</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading11" data-toggle="collapse"
                                                href="#de_syllabus11" aria-expanded="true" aria-controls="de_syllabus11">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i>K-Means Clustering
                                 </h6>
                                            </div>
                                            <div id="de_syllabus11" class="collapse " aria-labelledby="de_heading11"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Clustering</li>
                                                        <li>K Means Clustering</li>
                                                        <li>K Means Algorithm</li>
                                                        <li>Examples for K- Means</li>
                                                        <li> K- Means Clustering Steps</li>
                                                        <li>K-Means algorithm</li>
                                                        <li>K-Means coding import library</li>
                                                        <li>K-Means elbow method</li>
                                                        <li>Fitting K-Means</li>
                                                        <li> Visualizing Clusters </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading12" data-toggle="collapse"
                                                href="#de_syllabus12" aria-expanded="true" aria-controls="de_syllabus12">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i>Association Rule Learning
                                 </h6>
                                            </div>
                                            <div id="de_syllabus12" class="collapse " aria-labelledby="de_heading12"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Association Rule Learning (ARL</li>
                                                        <li>Usefulness of ARL</li>
                                                        <li>Applications of ARL</li>
                                                        <li>Challenges of ARL</li>
                                                        <li>Merits of ARL </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading13" data-toggle="collapse"
                                                href="#de_syllabus13" aria-expanded="true" aria-controls="de_syllabus13">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus"></i> Dimentionality Reduction
                                                </h6>
                                            </div>
                                            <div id="de_syllabus13" class="collapse " aria-labelledby="de_heading13"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Introduction to Dimentionality Reduction</li>
                                                        <li>Principal Component Analysis (PCA)</li>
                                                        <li>Important Conclusions</li>
                                                        <li>Implementation of PCA - Part 1</li>
                                                        <li>Implementation of PCA - Part 2</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading14" data-toggle="collapse"
                                                href="#de_syllabus14" aria-expanded="true" aria-controls="de_syllabus14">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus" id="Learning-Outcomes"></i>Model Evaluation
                                                </h6>
                                            </div>
                                            <div id="de_syllabus14" class="collapse " aria-labelledby="de_heading14"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li>Types of Evaluation</li>
                                                        <li>Model Accuracy & Error Rate</li>
                                                        <li>Kappa Value</li>
                                                        <li>Model Sensitivity and Specificity</li>
                                                        <li>Model Precision and Recall and F-Measure</li>
                                                        <li>ROC Curves</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="panel panel-info">
                                            <div class="panel-heading" id="de_heading15" data-toggle="collapse"
                                                href="#de_syllabus15" aria-expanded="true" aria-controls="de_syllabus15">
                                                <h6 class="panel-title">
                                                    <i class="indicator fa fa-plus" ></i >Project Ideas
                                                </h6>
                                            </div>
                                            <div id="de_syllabus15" class="collapse " aria-labelledby="de_heading15"
                                                data-parent="#de_syllabus">
                                                <div class="panel-body">
                                                    <ul class="syllabus-ul">
                                                        <li >Project Ideas</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
                    <div class="row">
                        <div class="col-sm-6">
                            <h3 >Learning Outcomes</h3>
                            <ul class="lo-ul">
                                <li>Make accurate predictions</li>
                                <li>Use for personal purpose</li>
                                <li>Recognize the Machine Learning model to choose for each problem</li>
                                <li>Understand various powerful Machine Learning models</li>
                                <li>Analyze data effectively</li>
                                <li>Apply dimensionality reduction technique to data</li>
                                <li>Solutions to business problems</li>
                            </ul>
                            <br />
                            <h3>Assessment</h3>
                            <div class="table-responsive course-batch-schedule">
                                <div class="card">
                                    <table class="table">
                                        <thead>
                                            <tr class="text-center">
                                                <th >Type</th>
                                                <th >Weightage %</th>
                                            </tr>
                                        </thead>
                                        <tbody id="Reviews">
                                            <tr class="content-size">
                                                <td >Content</td>
                                                <td >100%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <img src="/assets/images/icons/certificate1.jpg" alt="Online Machine Learning Course" />
                        </div>
                    </div>
                    <br /><br />
                </section>
                <Aboutuslearners />
                <Aluminicompany />
                <section class="courses-feesm">
                    <section class="course-fees" id="course-fees">
                        <div class="row box-sh" >
                            <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                            <Intrestedinprogram/>
                            </div>
                            <div class="vertical-line-fee"> </div>
                            <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                                <div class="row">
                                    <div class="col-sm-10"> <br /><br />
                                        <h5>Features</h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <ul class="highlight-ss" >
                                            <li> Dr.Vijay Gaikwad as a knowledge partner.</li>
                                            <li>Mentorship by industry specialists.</li>
                                            <li>Course awarded by Edu Plus Now.</li>
                                            <li>Self pased learning.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
                <Whyedu />
                <section class="course-about-instructor bg-blues" id="course-about-instructor" >
            <div class="row">
               <div class="col-sm-12">
                  <h3>
                  About the Instructor
                  </h3>
                  <br />
                  <div class="about-ist">
                     <div class="card pd-abt-ist">
                        <div class="social-instructor">
                           <img onerror="this.onerror=null;this.src='https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg';" alt="" src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/7_vgaikwad.jpg" />
                        </div>
                        <div class="inst-details">
                           <h3>Vijay Gaikwad</h3>
                           <p>15 Years Of Experience</p>
                           <br />
                           <h4>Vishwakarma Institute of Technology, Pune</h4>
                           <p align="justify">Associate Professor & Head- Electronics Engineering Department</p>
                           <br />
                           <ul class="course-about-ul">
                              <li>
                                 <a href="https://www.facebook.com/vdgaikwad81" target="_blank" rel="noreferrer">
                                 <FontAwesomeIcon icon={faBell} />
                                 </a>
                              </li>
                              <li>
                                 <a href="https://www.linkedin.com/in/vdgaikwad81/" target="_blank" rel="noreferrer">
                                 <FontAwesomeIcon icon={faBell} />
                                 </a>
                              </li>
                              <li>
                                 <a href="https://twitter.com//vdgaikwad81" target="_blank" rel="noreferrer">
                                 <FontAwesomeIcon icon={faBell} />
                                 </a>
                              </li>
                              <li >
                                 <FontAwesomeIcon icon={faBell} />
                              
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            </section>
            </div>
        );
    }
}

export default Machinelearning;